import { type FC } from 'react'

import { type CategoryHierarchyResponseDto } from './CategoryHierarchyResponseDto.type'
import { StoryblokCategoryNavigationButton } from './mobile/StoryblokCategoryNavigationButton'
import { StoryblokCategoryNavigationProvider } from './mobile/StoryblokCategoryNavigationProvider'
import { StoryblokCategoryNavigationSlider } from './mobile/StoryblokCategoryNavigationSlider'

export const StoryblokCategoryNavigationMobile: FC<{
  initialCategoryData?: CategoryHierarchyResponseDto | null
}> = ({ initialCategoryData }) => {
  if (!initialCategoryData) {
    return null
  }

  return (
    <section className="container flex items-center tablet:hidden">
      <StoryblokCategoryNavigationProvider
        initialCategoryData={initialCategoryData}
      >
        <StoryblokCategoryNavigationButton />
        <StoryblokCategoryNavigationSlider />
      </StoryblokCategoryNavigationProvider>
    </section>
  )
}
